module.exports = __webpack_public_path__ + "static/img_2567-8e3693b79cd1305172440459b45e200c.webp";